module.exports = __webpack_public_path__ + "static/media/contact-form-success.c72c21eb.svg";